import { useMemo, useState } from 'react';
import { If } from '~/components';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import OnboardingContract from './OnboardingContract';
import OnboardingContractResume from './OnboardingContractResume';

const OnboardingContractContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const [acceptedTermsAndPolicy, setAcceptedTermsAndPolicy] = useState(false);
  const [isContractVisible, setIsContractVisible] = useState(false);

  const getTexts = useMemo(() => {
    const contract = user.termsAndPolicy.regulatoryDocuments.find(
      (item) => item.type === 'CREDIT_CONTRACT',
    );

    return {
      text: contract?.text,
    };
  }, [user.termsAndPolicy.regulatoryDocuments]);

  const handleNext = async () => {
    await user.acceptContract();
    navigate(Routes.ONBOARDING_SIGNATURE);
  };

  return (
    <>
      <If condition={!isContractVisible}>
        <OnboardingContractResume
          agreeWithContract={acceptedTermsAndPolicy}
          setAgreeWithContract={setAcceptedTermsAndPolicy}
          seeContract={() => setIsContractVisible(true)}
          handleNext={handleNext}
        />
      </If>
      <If condition={!!isContractVisible}>
        <OnboardingContract
          markdown={getTexts.text || ''}
          agreeWithContract={() => {
            setAcceptedTermsAndPolicy(true);
            setIsContractVisible(false);
          }}
          backContract={() => {
            setIsContractVisible(false);
          }}
        />
      </If>
    </>
  );
};

export default observer(OnboardingContractContainer);
